var map = {
	"./color1.png": 5409,
	"./color10.png": 1365,
	"./color2.png": 650,
	"./color3.png": 8403,
	"./color4.png": 2156,
	"./color5.png": 4421,
	"./color6.png": 8670,
	"./color7.png": 1159,
	"./color8.png": 64,
	"./color9.png": 8185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1607;